export enum ThermalCalculationMode {
  ADIABATIC = 'Adiabatic',
  ISOTHERMAL = 'Isothermal',
  THERMAL = 'Thermal',
}
